import React from 'react';

import { Redirect, Prompt } from "react-router-dom";
import { Link } from 'react-router-dom';
import Header from "../../../components/Header";
import TextInput from "../../../components/Form/components/TextInput";
import LoadingSpinner from "../../../components/LoadingSpinner";
import SelectInput from "../../../components/Form/components/SelectInput";
import SuburbAutoComplete from '../../../components/Form/components/AutoCompleteInput/SuburbAutoComplete';
import UserAutoComplete from '../../../components/Form/components/AutoCompleteInput/UserAutoComplete';
import { COUNTRY_STATE_OPTIONS_NZ, COUNTRY_STATE_OPTIONS_AU } from "../../../helpers/Constants";
import PostcodeTextInput from '../../../components/Form/components/TextInput/PostcodeTextInput';
import UserTable from './components/StoreUserTables';
import PageTitle from "../../../components/PageTitle";
//services
import withAuth from "../../../services/withAuth";
import AuthService from "../../../services/AuthService";
import MembersApi from "../../../services/portal-api/MembersApi";
import GlobalsApi from '../../../services/portal-api/GlobalsApi';
import NotFound from '../../NotFound';
import CheckboxInput from '../../../components/Form/components/CheckboxInput';
import PassTips from "../../../components/HelpTip/passwordHint";
import swal from 'sweetalert';

class EditStore extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            data: {
                storeId: '',
                storeName: '',
                postcode: '',
                countryState: '',
                suburb: '',
                user: '',
                uname: '',
                password: '',
                passwordRe: '',
                email: '',
                country: '',
                admin: '',
                timeoutPeriod: 0,
                useGlobal: true,
                resetPassword: true,
                primaryIp: '',
                secondaryIp: ''
            },
            userlist: [],
            users: [],
            errors: {},
            viewSlug: null,
            forbidden: false,
            countStoreAdmins: 0,
            suggestions: [],
            passwordmandatory: true,
            tempUName: '',
            showTextbox: true,
            sortKey: 'username',
            sortValue: 'ASC',
        }
        this.searchSuburbs = this.searchSuburbs.bind(this);
        this.handleSuburbSelected = this.handleSuburbSelected.bind(this);
        this.stringSuburbs = '';
        this.handleUserSelected = this.handleUserSelected.bind(this);

    }

    componentDidMount() {
        document.title = 'Edit Store - duskPortal';
        document.body.className = 'page--green';

        if (sessionStorage.getItem("globals_nz") == null) {
            GlobalsApi.getSuburbs('NZ', (result, callId) => {
                sessionStorage.setItem("globals_nz", JSON.stringify(result.json));
                this.stringSuburbs = JSON.stringify(result.json);
                this.forceUpdate();
            });
        }

        if (sessionStorage.getItem("globals_au") == null) {
            GlobalsApi.getSuburbs('AU', (result, callId) => {
                sessionStorage.setItem("globals_au", JSON.stringify(result.json));
                this.stringSuburbs = JSON.stringify(result.json);
                this.forceUpdate();
            });
        }
        this._selectCountry();
        console.log("pass ", AuthService.can('Is change password at next login mandatory'))

    }

    _sessionParentUser = (response) => {
        // Check for auth
        if (response.status === 401) {
            this.props.sessionExpired();
            this.setState({
                isLoading: false,
            });
            return;
        } else {
            // alert("Something went wrong");
            swal("Something went wrong", {
                icon: "warning",
                buttons: false,
                timer: 3000
            });
        }
    }

    _loadStore() {

        MembersApi.getStoreDetails((result) => {
            if (result.success) {
                let { data, forbidden } = this.state;
                result.json.primary_ip;
                let ip = '';
                if (result.json.primary_ip != '') {
                    const parsedIp = JSON.parse(result.json.primary_ip);
                    if (Array.isArray(parsedIp)) {
                        ip = parsedIp.join(', ');
                    }
                }
                data['storeName'] = result.json.name;
                data['postcode'] = result.json.postcode;
                data['countryState'] = result.json.state.toLowerCase();
                data['suburb'] = result.json.suburb;
                data['storeId'] = result.json.id;
                data['primaryIp'] = ip;
                if (!AuthService.getAdminType() == 1 && AuthService.getFuturaStoreId() != result.json.id) {
                    forbidden = true;
                }
                this.setState({
                    'data': data,
                    'forbidden': forbidden,
                }, () => {
                    if (!this.state.forbidden) { this._loadListing(); }
                });
            } else {
                this.setState({
                    'forbidden': true,
                    'isLoading': false,
                });
            }
        }, this.props.match.params.id);

        console.log(this.state);
    }

    _loadListing() {
        MembersApi.fetchUsersInStore((result) => {
            if (result.success) {
                let stadmins = 0;
                result.json.forEach((usr, ind) => {
                    if (usr.is_admin == 2) {
                        stadmins++;
                    }
                });

                sessionStorage.setItem('store-admins', stadmins);

                this.setState({
                    'users': result.json,
                    'countStoreAdmins': stadmins
                });
            }
        }, this.props.match.params.id);
    }

    sort = (column) => {
        this.setState(prevState => ({
            sortValue: prevState.sortValue === "ASC" ? "DESC" : "ASC",
            sortKey: column
        }), () => {
            let filteredData = [...this.state.users];
            const sortKey = (this.state.sortKey == 'last_logged_in_time') ? 'formated_last_logged_in' : 'uname';
            if(sortKey === 'uname') {
                filteredData.sort((a, b) => {
                    const usernameA = a[sortKey].toUpperCase();
                    const usernameB = b[sortKey].toUpperCase();
                
                    if (this.state.sortValue === "ASC") {
                        return usernameA.localeCompare(usernameB);
                    } else {
                        return usernameB.localeCompare(usernameA);
                    }
                });
            } else {
                if (this.state.sortValue === 'ASC') {
                    filteredData.sort((a, b) => {
                        if (a.formated_last_logged_in === '') {
                        return 1; 
                        } else if (b.formated_last_logged_in === '') {
                        return -1;
                        }
                
                        const dateA = new Date(a.formated_last_logged_in.split('/').reverse().join('/'));
                        const dateB = new Date(b.formated_last_logged_in.split('/').reverse().join('/'));
                        return dateA - dateB;
                    });
                } else {
                    filteredData.sort((a, b) => {
                        if (a.formated_last_logged_in === '') {
                        return -1; 
                        } else if (b.formated_last_logged_in === '') {
                        return 1; 
                        }
                
                        const dateA = new Date(a.formated_last_logged_in.split('/').reverse().join('/'));
                        const dateB = new Date(b.formated_last_logged_in.split('/').reverse().join('/'));
                        return dateB - dateA;
                    });
                }
            }
            

            this.setState({
                users: filteredData,
            }, () => {
                console.log("Sort...");
            });
        })
    }

    _selectCountry() {
        MembersApi.getCountry((result, callId) => {
            const { data } = this.state;
            if (result.json.country == "NZ") {
                data["country"] = "globals_nz";

            } else if (result.json.country == "AU") {
                data["country"] = "globals_au";

            }
            if (result.success) {
                this.setState({
                    'data': data,
                }, () => {
                    this._loadStore();
                });
            } else {
                if (result.status === 401) {
                    this.props.sessionExpired();
                    this.setState({
                        isLoading: false,
                    });
                    return;
                }
            }
        });

    }

    handleSuburbSelected(suburb) {
        const { data } = this.state;
        data['suburb'] = suburb.suburb;
        data['postcode'] = suburb.postcode;
        data['countryState'] = suburb.state.toLowerCase();

        this.setState({
            data: data,
        });
    }

    handleUserSelected(uname) {
        const { data } = this.state;
        data['uname'] = uname.uname.value;
        this.setState({
            data: data,
            passwordmandatory: false,
            tempUName: uname.uname.value,
            showTextbox: false,
        });
    }


    handleInput = (event) => {
        const errors = this.state.errors;
        const name = event.target.name;
        delete errors[name];
        let data = this.state.data;
        let passwordmandatory = this.state.passwordmandatory;
        let showTextbox = this.state.showTextbox;
        if (name == "timeoutPeriod") {
            data[name] = event.target.value == '' ? 0 : event.target.value;
            if (isNaN(data[name]) || data[name] < 0) {
                errors["timeoutPeriod"] = "The Inactivity Timeout needs to be a valid number greater than 0.";
            }

        } else if (name == "useGlobal") {
            data[name] = event.target.checked;
            data["timeoutPeriod"] = data[name] ? 0 : data["timeoutPeriod"];
            delete errors["timeoutPeriod"];
        } else if (name == "uname") {
            if (this.state.tempUName != event.target.value) {
                passwordmandatory = true;
                data[name] = event.target.value;
                showTextbox = true;
            }
        } else if (name == "primaryIp") {
            data[name] = event.target.value == '' ? '' : event.target.value;
        } else {
            data[name] = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        }

        this.setState({
            data: data,
            errors: errors,
            isEdited: true,
            passwordmandatory: passwordmandatory,
            showTextbox: showTextbox,
        });
    }

    searchSuburbs(_value) {
        const value = _value.toLowerCase().trim();
        const {
            suburbs,
        } = this.state;

        if (suburbs) {
            const matches = suburbs.filter(sub => sub.key.indexOf(value) !== -1)
            const distanceMatches = matches.map(m => ({ ...m, dist: m.key.length - value.length }));
            distanceMatches.sort((a, b) => a.dist - b.dist);
            return distanceMatches;
        }
        return [];
    }

    removeUser = (id) => {
        const updatedUsers = this.state.users.filter(user => user.uid !== id);
        this.setState({ users: updatedUsers });
    }

    updateIsActive = () => {
        this._loadListing();
    }

    handleSubmit = (event) => {

        // Prevent default behaviour
        event.preventDefault();

        // Show loading and reset state
        this.setState({
            isLoading: true,
            errors: {},
        });

        // Fetch data
        MembersApi.updateStore(this.state.data, (response) => {

            // Check for errors
            if (response.success) {
                // Redirect away
                this.setState({
                    isLoading: false,
                    isEdited: false,
                    viewSlug: response.json.message,
                }, () => {
                    this._loadListing();
                });
            }
            else {
                // Check for auth
                if (response.status === 401) {
                    this.props.sessionExpired();
                    this.setState({
                        isLoading: false,
                    });
                    return;
                }

                if (response.json.errors) {
                    this.setState({
                        isLoading: false,
                        errors: response.json.errors,
                    });
                }
                else if (response.json.error) {
                    this.setState({
                        isLoading: false,
                        errors: { error: response.json.error },
                    });
                }
                else {
                    this.setState({
                        isLoading: false,
                    });
                }
            }
            window.scrollTo(0, 0);
        });
    };

    handleSubmitUser = (event) => {

        // Prevent default behaviour
        event.preventDefault();

        const { admin } = this.state.data
        if (admin == "store_admin" && this.state.countStoreAdmins >= 2) {
            window.scrollTo(0, 0);
            this.setState({
                viewSlug: null,
                errors: { 'admin': "The Store can't have more than 2 Store Admins" }
            });
            return;
        }

        let passwordValidDefinition = [
            {
                minLength: 6,
                ErrorMessage: "Your password must be at least six characters long.",
            },
            {
                maxLength: 50,
                ErrorMessage: "Your password cannot be longer than 50 characters.",
            },
            {
                regex: /.*\d/,
                ErrorMessage: "Your password must contain at least one digit.",
            },
            {
                regex: /.*[a-zA-Z]/,
                ErrorMessage: "Your password must contain at least one letter.",
            },
            {
                regex: /.*[!@#$%^&*() =+_-]/,
                ErrorMessage: "Your password must contain at least one symbol in this list !@#$%^&*()=+_- or a space.",
            },
        ];

        let password = this.state.data.password;
        let isvalid = true;
        const errors = this.state.errors;
        delete errors["regex"];
        delete errors["minLength"];
        delete errors["maxLength"];
        delete errors["reConfirm"];
        delete errors["admin"];
        delete errors["error"];

        if (this.state.passwordmandatory == true) {
            if (password != this.state.data.passwordRe) {
                errors["reConfirm"] = "The confirmation password does not match or is empty.";
                isvalid = false;
            }

            for (let i = 0; i < passwordValidDefinition.length; i++) {
                let validator = passwordValidDefinition[i];

                if (validator.hasOwnProperty("regex")) {
                    if (password.search(validator.regex) < 0) {
                        errors["regex"] = validator.ErrorMessage; isvalid = false;
                    }

                }

                if (validator.hasOwnProperty("minLength")) {
                    if (password.length < validator.minLength) {
                        errors["minLength"] = validator.ErrorMessage; isvalid = false;
                    }
                }

                if (validator.hasOwnProperty("maxLength")) {
                    if (password.length > validator.maxLength) {
                        errors["maxLength"] = validator.ErrorMessage; isvalid = false;
                    }
                }
            }

            this.setState({
                errors: errors,
                viewSlug: null
            });

            if (!isvalid) {
                window.scrollTo(0, 0);
                return false;
            }
        }

        if (errors["timeoutPeriod"] != undefined) {
            return false;
        }

        // Show loading and reset state
        this.setState({
            isLoading: true,
            errors: {},
        });


        let serializedInstances = [
            {
                "store": this.state.data.storeId,
                "admin": this.state.data.admin
            }
        ];

        const sendParams = {
            ...this.state.data,
            instances: JSON.stringify(serializedInstances),
            store: this.state.data.storeId,
            addExistingUser: 1,
        };

        if (!AuthService.getAdminType() == 1) {
            delete sendParams['timeoutPeriod'];
        }

        // Fetch data
        MembersApi.multiAddUser(sendParams, (response) => {

            // Check for errors
            if (response.success) {
                // Redirect away
                const { data } = this.state;
                data['uname'] = '';
                data['password'] = '';
                data['passwordRe'] = '';
                data['resetPassword'] = true,
                    data['email'] = '';
                data['admin'] = '';
                data['timeoutPeriod'] = 0;
                data.passwordmandatory = true;
                data.tempUName = '';

                this.setState({
                    isLoading: false,
                    isEdited: false,
                    data: data,
                    viewSlug: response.json.message,
                }, () => {
                    this._loadListing();
                });
            }
            else {
                // Check for auth
                if (response.status === 401) {
                    this.props.sessionExpired();
                    this.setState({
                        isLoading: false,
                        viewSlug: null
                    });
                    return;
                }

                if (response.json.errors) {
                    this.setState({
                        isLoading: false,
                        errors: response.json.errors,
                        viewSlug: null
                    });
                }
                else if (response.json.error) {
                    this.setState({
                        isLoading: false,
                        errors: { error: response.json.error },
                        viewSlug: null
                    });
                }
                else {
                    this.setState({
                        isLoading: false,
                        viewSlug: null
                    });
                }
            }
            window.scrollTo(0, 0);
        });
    };


    render() {
        console.log("AuthService.getAdminType() ", AuthService.getAdminType());
        const viewUrl = AuthService.getAdminType() == 1 ? '/new-store' : '/';
        let admins = [];
        let pageTitle = AuthService.getAdminType() == 1 ? 'Edit Store' : 'Add User';
        let c = '';
        if (this.state.viewSlug) {
            //return (<Redirect to={'/members/' + this.state.viewSlug} />);
            console.log(this.state.viewSlug);
            c = <div className="alert alert--success alert--outline text--center margin--20">{this.state.viewSlug}</div>
        }
        const errorsmsg = [];
        for (const [key, value] of Object.entries(this.state.errors)) {
            errorsmsg.push(<li key={key}><span>Sorry, <strong>{value}</strong> Please try again, or contact Super Admin if the problem persists.</span></li>);
        }
        let countryOptions = null;
        if (!this.state.data.country) {
            countryOptions = [];
        } else {
            if (this.state.data.country == "globals_nz")
                countryOptions = COUNTRY_STATE_OPTIONS_NZ;
            if (this.state.data.country == "globals_au")
                countryOptions = COUNTRY_STATE_OPTIONS_AU;
        }

        let { storeName } = this.state.data;


        admins = [{ key: "store_admin", value: "Store Admin" }, { key: "user", value: "Store User" }];

        if (storeName.toLowerCase().trim() == 'customer support') {
            if (AuthService.getAdminType() == 1) {
                admins = [
                    { key: "super_admin", value: "Super Admin" },
                    { key: "cs_admin", value: "Customer Support Admin" },
                    { key: "user", value: "Store User" }
                ];
            } else if (AuthService.getAdminType() == 3) {
                admins = [
                    { key: "cs_admin", value: "Customer Support Admin" },
                    { key: "user", value: "Store User" }
                ];
            }
        }

        let loaderOffset = {
            top: 200,
            position: 'absolute',
            left: '50%',
        }

        if (this.state.forbidden) {

            return (
                <NotFound forbidden={true}>
                    {this.state.isLoading &&
                        <div style={{ position: 'absolute', height: '100%', width: '100%', top: 0, background: '#fff', zIndex: 7777, opacity: 0.8 }}>
                            <div className="sk-fading-circle" style={loaderOffset}>
                                <div className="sk-circle1 sk-circle" />
                                <div className="sk-circle2 sk-circle" />
                                <div className="sk-circle3 sk-circle" />
                                <div className="sk-circle4 sk-circle" />
                                <div className="sk-circle5 sk-circle" />
                                <div className="sk-circle6 sk-circle" />
                                <div className="sk-circle7 sk-circle" />
                                <div className="sk-circle8 sk-circle" />
                                <div className="sk-circle9 sk-circle" />
                                <div className="sk-circle10 sk-circle" />
                                <div className="sk-circle11 sk-circle" />
                                <div className="sk-circle12 sk-circle" />
                            </div>
                        </div>
                    }
                </NotFound>);

        } else {


            return (
                // (AuthService.getAdminType() == 1 || AuthService.getAdminType() == 2 || AuthService.getAdminType() == 4) ?
                AuthService.can('edit stores') || AuthService.can('store users') ?
                    <div>
                        <Header />
                        <main className="content padding--80--bot" role="main">
                            <div className="container padding--60--top clearfix">

                                <header className="header--page clearfix">

                                    <PageTitle back={viewUrl} title={pageTitle} />

                                </header>
                                {errorsmsg.length > 0 && <ul className="alert alert--outline alert--error margin--40--top">
                                    {errorsmsg}
                                </ul>}
                                {c}

                                {/* store form */}
                                {AuthService.can('edit stores') &&
                                    <form onSubmit={this.handleSubmit} className="margin--40--top validate loading--inline padding--90--bot" autoComplete="off">
                                        <span></span>
                                        <div className="col-2 gutter--40">
                                            <div className="col">
                                                <TextInput
                                                    name="storeName"
                                                    label="Store Name"
                                                    value={this.state.data.storeName}
                                                    error={this.state.errors.storeName}
                                                    onChange={this.handleInput}
                                                    required={true}
                                                />
                                            </div>
                                            <div className="col">
                                                <div className="col-3 gutter--15 suburb-state-postcode">
                                                    <div className="col">
                                                        <SuburbAutoComplete
                                                            name="suburb"
                                                            label="Suburb (Optional)"
                                                            value={this.props.match.params.slug}
                                                            error={this.state.errors.suburb}
                                                            onChange={this.handleInput}
                                                            onSuburbSelected={this.handleSuburbSelected}
                                                            country={this.state.data.country}
                                                            extras={this.stringSuburbs}
                                                        />
                                                    </div>
                                                    <div className="col">
                                                        <SelectInput
                                                            name="countryState"
                                                            label="State"
                                                            options={countryOptions}
                                                            value={this.state.data.countryState}
                                                            error={this.state.errors.countryState}
                                                            onChange={this.handleInput}
                                                            required={true}
                                                        />
                                                    </div>
                                                    <div className="col">
                                                        <PostcodeTextInput
                                                            name="postcode"
                                                            label="Postcode"
                                                            value={this.state.data.postcode}
                                                            error={this.state.errors.postcode}
                                                            onChange={this.handleInput}
                                                            required={true}
                                                        />
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                        <div className="col-2 gutter--40">
                                            <div className="col">
                                                <TextInput
                                                    name="primaryIp"
                                                    label="Private IPs of stores to whitelist (Comma Separated)"
                                                    value={this.state.data.primaryIp}
                                                    error={this.state.errors.primaryIp}
                                                    onChange={this.handleInput}
                                                />
                                            </div>
                                        </div>

                                        <footer className="footer--form clearfix">
                                            <div className="footer--form__left">
                                            </div>
                                            <div className="footer--form__right">
                                                <button type="submit" className="btn btn--large btn--color">Update</button>
                                            </div>
                                        </footer>

                                    </form>
                                }

                                {/* user form */}
                                {AuthService.can('create store users') &&
                                    <form onSubmit={this.handleSubmitUser} className={AuthService.can('create store users') ? "validate loading--inline " : "margin--40--top validate loading--inline padding--90--bot"} autoComplete="off">
                                        <span></span>

                                        <div className="col-2 gutter--40 ">
                                            <div className="col">
                                                <UserAutoComplete
                                                    name="uname"
                                                    label="Username"
                                                    value={this.state.data.uname}
                                                    error={this.state.errors.uname}
                                                    onChange={this.handleInput}
                                                    onSuburbSelected={this.handleUserSelected}
                                                />
                                            </div>
                                            <div className="col">
                                                <SelectInput
                                                    name="admin"
                                                    label="User Type"
                                                    options={admins}
                                                    value={this.state.data.admin}
                                                    error={this.state.errors.countryState}
                                                    onChange={this.handleInput}
                                                    required={true}
                                                />
                                            </div>
                                            {this.state.showTextbox && <React.Fragment><div className="col">
                                                <TextInput
                                                    type="password"
                                                    name="password"
                                                    label="Password"
                                                    value={this.state.data.password}
                                                    error={this.state.errors.password}
                                                    onChange={this.handleInput}
                                                    required={this.state.passwordmandatory}
                                                    tooltip={<PassTips>
                                                        <ul>
                                                            <li><span>Leave the password empty if you are adding an exsiting user to the store.</span></li>
                                                            <li><span>Your password must be at least six characters long.</span></li>
                                                            <li><span>Your password must contain at least one digit and one letter</span></li>
                                                            <li><span>Your password must contain at least one symbol in this list !@#$%^&*()=+_- or a space.</span></li>
                                                        </ul>
                                                    </PassTips>}
                                                />
                                            </div>
                                                <div className="col">
                                                    <TextInput
                                                        type="password"
                                                        name="passwordRe"
                                                        label="Re-confirm Password"
                                                        value={this.state.data.passwordRe}
                                                        error={this.state.errors.passwordRe}
                                                        onChange={this.handleInput}
                                                        required={this.state.passwordmandatory}
                                                        tooltip={<PassTips>
                                                            <ul>
                                                                <li><span>Leave the password empty if you are adding an exsiting user to the store.</span></li>
                                                                <li><span>Your password must be at least six characters long.</span></li>
                                                                <li><span>Your password must contain at least one digit and one letter</span></li>
                                                                <li><span>Your password must contain at least one symbol in this list !@#$%^&*()=+_- or a space.</span></li>
                                                            </ul>
                                                        </PassTips>}
                                                    />
                                                </div></React.Fragment>}
                                            {AuthService.getAdminType() == 1 &&
                                                <div className="col"> <div className="col-2 gutter--40 ">
                                                    <div className="col">
                                                        <TextInput
                                                            type="text"
                                                            name="timeoutPeriod"
                                                            label="Inactivity Timeout (Mins)"
                                                            placeholder="Enter minutes .."
                                                            value={this.state.data.timeoutPeriod == 0 ? '' : this.state.data.timeoutPeriod}
                                                            error={this.state.errors.timeoutPeriod}
                                                            onChange={this.handleInput}
                                                            required={false}
                                                            disabled={this.state.data.useGlobal ? true : false}
                                                        />
                                                    </div>
                                                    <div className="col">
                                                        <CheckboxInput
                                                            name="useGlobal"
                                                            title=""
                                                            label={"Use global timeout settings"}
                                                            isChecked={this.state.data.useGlobal}
                                                            onChange={this.handleInput}
                                                        />
                                                    </div>
                                                </div></div>}
                                            {this.state.showTextbox && <div className="col">
                                                <CheckboxInput
                                                    name="resetPassword"
                                                    title=""
                                                    label={"Change password at next login"}
                                                    isChecked={this.state.data.resetPassword}
                                                    onChange={this.handleInput}
                                                    disabled={AuthService.can('Is change password at next login mandatory') ? true : false}
                                                />
                                            </div>}
                                            <footer className="footer--form clearfix">
                                                <div className="footer--form__left">

                                                </div>
                                                <div className="footer--form__right">
                                                    <button type="submit" className="btn btn--large btn--color">Add User</button>
                                                </div>
                                            </footer>
                                        </div>
                                    </form>
                                }
                            </div>

                            {AuthService.can('view store users') &&
                                <UserTable
                                    users={this.state.users}
                                    storeName={this.state.data.storeName}
                                    sessionLog={this._sessionParentUser}
                                    removeUser={this.removeUser}
                                    updateIsActive={this.updateIsActive}
                                    sort={this.sort}
                            />
                            }

                            {this.state.isLoading && <div style={{ position: 'absolute', height: '100%', width: '100%', top: 0, background: '#fff', zIndex: 7777, opacity: 0.8 }}>
                                <div className="sk-fading-circle" style={loaderOffset}>
                                    <div className="sk-circle1 sk-circle" />
                                    <div className="sk-circle2 sk-circle" />
                                    <div className="sk-circle3 sk-circle" />
                                    <div className="sk-circle4 sk-circle" />
                                    <div className="sk-circle5 sk-circle" />
                                    <div className="sk-circle6 sk-circle" />
                                    <div className="sk-circle7 sk-circle" />
                                    <div className="sk-circle8 sk-circle" />
                                    <div className="sk-circle9 sk-circle" />
                                    <div className="sk-circle10 sk-circle" />
                                    <div className="sk-circle11 sk-circle" />
                                    <div className="sk-circle12 sk-circle" />
                                </div>
                            </div>}
                        </main>
                    </div>
                    : <NotFound forbidden={true} />
            );
        }
    }

}

export default withAuth(EditStore);
